import { Component, OnInit, Input, ViewChild, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { AllCommunityModules, GridOptions, SortChangedEvent, FilterChangedEvent, GridReadyEvent, IGetRowsParams } from '@ag-grid-community/all-modules';
import { SummaryColumn, Summary } from '../objects/SummaryObject';
import { AgGridAngular } from '@ag-grid-community/angular';
import { FirstDataRenderedEvent } from '@ag-grid-community/core/dist/cjs/events';
import { MatCheckboxChange } from '@angular/material';
import { SummaryService } from '../services/summary.service';
import { AdvancedTableHeaderComponent } from '../advanced-table-header/advanced-table-header.component';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { AdvancedTableCustomLoadingComponent } from '../advanced-table-custom-loading/advanced-table-custom-loading.component';

@Component({
  selector: 'app-advanced-table',
  templateUrl: './advanced-table.component.html',
  styleUrls: ['./advanced-table.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AdvancedTableComponent implements OnInit {
  @ViewChild('agGrid') agGrid: AgGridAngular;
  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;
  
  noRowsTemplate;
  isSaving: boolean = false;
  columnDefs: any;
  rowData: any;
  modules = AllCommunityModules;
  columns: any = [];
  isFetching: boolean;
  initialLoad: boolean;
  blockSize:number = 10;
  rowCount: number = 0;
  totalRowsCount: number = 0;
  toggleClickExport: boolean = false;
  cleanedColState = [];
  frameworkComponents: { 
    customHeaderComponent: AdvancedTableHeaderComponent,
    customLoadingCellRenderer: AdvancedTableCustomLoadingComponent
   };


  gridOptions: GridOptions = {
    maxConcurrentDatasourceRequests: 1,
    defaultColDef: {
      headerComponentFramework: <{new():AdvancedTableHeaderComponent}>AdvancedTableHeaderComponent,
    },
    loadingCellRenderer: "customLoadingCellRenderer",
    loadingCellRendererParams: { loadingMessage: "One moment please..." },
    infiniteInitialRowCount: 1,
    cacheBlockSize: 100,
    rowModelType: "infinite",
    animateRows: true,
    rowSelection: "multiple",
    suppressDragLeaveHidesColumns: true,
    frameworkComponents: this.frameworkComponents

  }

  @Input() componentId: string;
  @Input() isPopup: boolean;
  @Input() set setSummary(summary: Summary){
    this.totalRowsCount = summary.TotalRows;
  }

  @Input() set setSummaryData(summaryData: any){
    summaryData.forEach(function(data, index) {
      data.id = data['#RowNumber'];
    });

    this.rowData = summaryData;
  }

  @Input() set setColumns(columns: SummaryColumn[]){
    var summaryColumns = columns;
    this.columnDefs = [];

    // var idCol = {field: "id"};
    // this.columnDefs.push(idCol);
    summaryColumns.forEach(column => {
      var colm;
      if (column.ColumnIsSorted){
        var sort = "desc";
        if (column.ColumnSortIsAsc) sort = "asc";
        colm = {headerName: column.PropertyDisplay, field: column.PropertyName, sortable: true, sort: sort, resizable: true, cellStyle: {'text-align': column.ViewColumnType == 'DISPLAYNUMBERFORMAT' ? 'right' : 'left'} }
      }
      else{
        colm = {headerName: column.PropertyDisplay, field: column.PropertyName, sortable: true, resizable: true, cellStyle: {'text-align': column.ViewColumnType == 'DISPLAYNUMBERFORMAT' ? 'right' : 'left'} }
      }
      
      this.columnDefs.push(colm);


      var displayColm = {headerName: column.PropertyDisplay, field: column.PropertyName, resizable: true, isChecked: true}
      this.columns.push(displayColm);
    });
  }

  @Output() exportSummary = new EventEmitter<boolean>();
  @Output() exportCurrentView = new EventEmitter<any>();

  constructor(private summaryService: SummaryService, private contextMenuService: ContextMenuService) { 
    this.summaryService.sortChanged$.subscribe(result => {
      if (result){
        if (result.column){
          this.sortByColumn(result.column.colDef.field);
        }
      }
    })

    this.summaryService.filterChanged$.subscribe(result => {
      if (result){
        if (result.column){
          // this.sortByColumn(result.column.colDef.field);
        }
      }
    })

    this.noRowsTemplate = "<span>No record found</span>";
  }

  ngOnInit() {
  }

  public onContextMenu($event): void {
    if($event.button == 0){
      this.contextMenuService.show.next({
        anchorElement: $event.target,
        contextMenu: this.basicMenu,
        event: $event,
        item: ''
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  rowClicked($event){
    console.log($event);
  }

  resizeColumn(){
    this.agGrid.columnApi.autoSizeAllColumns();
  }

  getSelectedRows(event){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map( node => node.data );
    const selectedDataStringPresentation = selectedData.map( node => node.DepartmentName);
  }

  gridReady(event: GridReadyEvent){
    this.getState();
    let self = this;
    var datasource = {
      rowCount: null,
      getRows: (params: IGetRowsParams) => {
        if (params.startRow == 0 && !this.initialLoad){
          this.initialLoad = true;
          this.agGrid.api.showLoadingOverlay();
          this.summaryService.getSummary(this.componentId).subscribe(result=> {
            var summary = JSON.parse(result);
            if (summary.Data.length == 0){
              this.agGrid.api.showNoRowsOverlay();
            }
            else{
              this.agGrid.api.hideOverlay();
            }
            
            this.totalRowsCount = summary.TotalRows;
            
            var summaryData = this.sortSummaryData(summary.Data);

            if (summaryData.length > 0) {
              var slicedData = summaryData.slice(params.startRow, params.endRow);
              slicedData.forEach(data => {
                data.id = data['#RowNumber'];
              });

              var lastRow = -1;
              if (summaryData.length < params.endRow) {
                lastRow = summaryData.length;
              }
              self.rowCount = summaryData.length;
              params.successCallback(slicedData, lastRow);
            }
            else{
              self.rowCount = 0;
              params.successCallback([], 0);
            }
          }, error => {
            this.agGrid.api.hideOverlay();
          })
        }
        else{
          this.initialLoad = false;
          self.fetchNextChunk(params.startRow, params.endRow).then(chunk => {
            var slicedData = chunk.slice(params.startRow, params.endRow);
            slicedData.forEach(data => {
              data.id = data['#RowNumber'];
            });

            var lastRow = -1;
            if (chunk.length < params.endRow) {
              lastRow = chunk.length;
            }
            
            self.rowCount = chunk.length;
            params.successCallback(slicedData, lastRow);
          });
        }
      }
    };
    event.api.setDatasource(datasource);
    
    setTimeout(() => {
      // event.columnApi.autoSizeAllColumns();
    });
  }

  firstDataRendered(event: FirstDataRenderedEvent){
  }

  sortChanged(event: SortChangedEvent){
    // console.log(event);
  }

  filterChanged(event: FilterChangedEvent){
    // console.log(event);
  }

  dragStopped(event){
  }

  onChange(selectedColumn:any, event:MatCheckboxChange){
    var column;

    column = this.columns.find(x => x.field == selectedColumn.field);

    this.agGrid.columnApi.setColumnVisible(column.field, event.checked);
  }

  fetchNextChunk(startRow: number, endRow: number): Promise<any[]> {
    return new Promise((resolve, reject) => {

      this.summaryService.nextPage(this.componentId).subscribe(result => {
        if (result == "1"){
          this.summaryService.getSummary(this.componentId).subscribe(result=> {
            var summary = JSON.parse(result);
            this.totalRowsCount = summary.TotalRows;
            var summaryData = this.sortSummaryData(summary.Data);
            resolve(summaryData);
          })
        }
      });
    });
  }

  refreshSummary($event){
    let self = this;
    var datasource = {
      rowCount: null,
      getRows: (params: IGetRowsParams) => {
        this.agGrid.gridOptions.api.hideOverlay();
        if (params.startRow == 0){
          this.summaryService.getSummary(this.componentId).subscribe(result=> {
            var summary = JSON.parse(result);
            var summaryData = this.sortSummaryData(summary.Data);
            this.totalRowsCount = summary.TotalRows;

            if (summaryData.length > 0) {
              var slicedData = summaryData.slice(params.startRow, params.endRow);
              slicedData.forEach(data => {
                data.id = data['#RowNumber'];
              });

              var lastRow = -1;
              if (summaryData.length < params.endRow) {
                lastRow = summaryData.length;
              }
              self.rowCount = summaryData.length;
              params.successCallback(slicedData, lastRow);
            }
            else{
              self.rowCount = 0;
              this.agGrid.gridOptions.api.showNoRowsOverlay();
              params.successCallback([], 0);
            }
          })
        }
        else{
          this.fetchNextChunk(params.startRow, params.endRow).then(chunk => {
            var slicedData = chunk.slice(params.startRow, params.endRow);
            slicedData.forEach(data => {
              data.id = data['#RowNumber'];
            });
            var lastRow = -1;
            if (chunk.length < params.endRow) {
              lastRow = chunk.length;
            }
            self.rowCount = chunk.length;
            params.successCallback(slicedData, lastRow);
          });
        }
      }
    };
    this.agGrid.api.setDatasource(datasource);
  }

  sortSummaryData(summaryData): any{
    return summaryData.sort((a:any,b:any) => { 
      if(parseInt(a["#RowNumber"]) > parseInt(b["#RowNumber"])){
        return 1;
      }else if(parseInt(a["#RowNumber"]) < parseInt(b["#RowNumber"])){
        return -1;
      }else{
        return 0;
      }
     });
  }

  sortByColumn(name:string){
    if (this.cleanedColState.length > 0){
      this.agGrid.columnApi.setColumnState(this.cleanedColState);
    }
    let self = this;
    let dataSource = {
      getRows(params: IGetRowsParams) {
        if (params.startRow == 0 && !this.isFetching){
          this.isFetching = true;
          self.agGrid.api.showLoadingOverlay();
          self.summaryService.ChangeSummaryTableSorting(self.componentId, name).subscribe(result => {
            if(result == "1"){
              self.summaryService.getSummary(self.componentId).subscribe(result=> {
                var summary = JSON.parse(result);
                this.totalRowsCount = summary.TotalRows;

                var summaryData = self.sortSummaryData(summary.Data);
                summaryData.forEach(function(data, index) {
                  data.id = data['#RowNumber'];
                });

                var lastRow = -1;
                if (summaryData.length < params.endRow) {
                  lastRow = summaryData.length;
                }
                
                this.isFetching = false;
                self.agGrid.api.hideOverlay();
                self.rowCount = summaryData.length;
                params.successCallback(summaryData, lastRow);

              })
            }
          }, error => {
            // self.agGrid.api.hideOverlay();
          })
        }
        else{
          self.fetchNextChunk(params.startRow, params.endRow).then(chunk => {
            var slicedData = chunk.slice(params.startRow, params.endRow);
            slicedData.forEach(function(data, index) {
              data.id = data['#RowNumber'];
            });

            var lastRow = -1;
            if (chunk.length < params.endRow) { // default next page
              lastRow = chunk.length;
            }
            self.rowCount = chunk.length;
            params.successCallback(slicedData, lastRow);
          });
        }
      }
    };

    this.gridOptions.api.setDatasource(dataSource);
  }
  
  onSave(){
    var columnsState = [];
    var sortModel = this.agGrid.gridOptions.api.getSortModel();
    this.agGrid.columnApi.getColumnState().forEach((element, index) => {
      var sortCol = sortModel.find(x => x.colId == element.colId);
      var colState: ColumnState = {
        field: element.colId,
        hide: element.hide,
        order: index,
        sort: sortCol ? sortCol.sort : null,
        width: element.width
      }
      columnsState.push(colState);
    });

    // this.isSaving = true;
    this.summaryService.updateSummaryColumnState(this.componentId, columnsState).subscribe(result => {
      if (result == "1"){
        
      }
      this.isSaving = false;
    }, error => {
      this.isSaving = false;
    })
  }

  getState(){
    this.summaryService.getSummaryColumnState(this.componentId).subscribe(result => {
      if (result){
        var colState = JSON.parse(result);
        this.cleanedColState = [];
      
        if (colState){
          colState.forEach(element => {
            var a = {
              colId : element.field,
              width : element.width,
              hide : element.hide
            };
  
            if (element.hide){
              this.columns.find(x => x.field == element.field).isChecked = false;
            }
  
            if(element.sort){
              this.agGrid.columnApi.getColumn(element.field).setSort(element.sort);
            }
  
            this.cleanedColState.push(a);
          });
        }
        
        if (this.cleanedColState.length > 0){
          this.initialLoad = false;
          this.agGrid.columnApi.setColumnState(this.cleanedColState);
        }
      }
    })
  }

  export(){
    this.exportSummary.emit(!this.toggleClickExport);
  }

  exportCurrent(){
    var columnsState = [];
    var sortModel = this.agGrid.gridOptions.api.getSortModel();
    this.agGrid.columnApi.getColumnState().forEach((element, index) => {
      var sortCol = sortModel.find(x => x.colId == element.colId);
      var colState: ColumnState = {
        field: element.colId,
        hide: element.hide,
        order: index,
        sort: sortCol ? sortCol.sort : null,
        width: element.width
      }
      columnsState.push(colState);
    });

    this.exportCurrentView.emit(columnsState);
  }
}

export interface ColumnState {
  field: string;  // propertyname
  hide: boolean;
  order: number;
  sort: string;
  width: number;
}